import React, { useEffect, useState, useContext } from "react";
import {
  Card,
  Image,
  Text,
  Badge,
  Button,
  Group,
  Modal,
  Tabs,
  LoadingOverlay,
  Divider,
  Tooltip,
  Loader,
  HoverCard,
} from "@mantine/core";
import axios from "axios";
import { Table } from "@mantine/core";
import { motion } from "framer-motion";
import SelectedCampaign from "./SelectedCampaign";
import { withAuthenticator } from "@aws-amplify/ui-react";
import "../App.css";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { SelectedContext } from "../Contexts/SelectedContext";
import HomePage from "./HomePage";
import { IconSearch, IconArchive, IconQuestionMark } from "@tabler/icons";
import UploadVOD from "./UploadVOD";
import { useMediaQuery } from "@mantine/hooks";
import { ActivityHeartbeat, Wallet } from "tabler-icons-react";
function ActiveCampaigns(props) {
  const { selected } = useContext(SelectedContext);
  const { user } = useAuthenticator((context) => [context.user]);
  const [opened, setOpened] = useState(false);
  const [opened2, setOpened2] = useState(false);
  const [currentDetails, setCurrentDetails] = useState();
  const [campaignSelected, setCampaignSelected] = useState("false");
  const [campaigns, setCampaigns] = useState();
  const [streamerId, setStreamerId] = useState();
  const [active, setActive] = useState();
  const [activeSponsors, setActiveSponsors] = useState();
  const [accept, setAccept] = useState();
  const [earnings, setEarnings] = useState();
  const [loading, setLoading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [deadline, setDeadline] = useState("");
  const [loadingActive, setLoadingActive] = useState(false);
  const [loadingAccept, setLoadingAccept] = useState(false);
  const today = new Date();

  let counter = 0;
  const matches = useMediaQuery("(min-width: 800px)");
  useEffect(() => {
    axios
      .post(
        "https://17eh5s1nff.execute-api.eu-north-1.amazonaws.com/doglass/",
        {},
        {
          headers: {
            Authorization: user.signInUserSession.idToken.jwtToken,
          },
        }
      )
      .then((res) => {
        if (res.data.errorType === "TypeError") {
          // console.log(res);
          setCampaigns([]);
        } else {
          // console.log(res.data);
          setActive(res.data.active);
          setEarnings(res.data.earnings);
          if (res.data.active != undefined && res.data.active.length > 0) {
            res.data.campaigns.map((campaign) => {
              if (campaign.campaign_id == res.data.active) {
                counter = counter + 1;
              }
            });
          }

          if (counter > 0) {
            setActiveSponsors(1);
          } else {
            changeActive("");
            setActiveSponsors(0);
          }
          // console.log("TESTAR");
          setStreamerId(res.data.streamer_id);
          setCampaigns(res.data.campaigns);
          // console.log(res.data.campaigns[0].streamers.bitlink_data.data)
          setLoading(true);
          setUploaded(false);
          //console.log(res.data.campaigns);
        }
      });
  }, [user, accept, active, uploaded]);

  const changeActive = (id) => {
    setLoadingActive(true);
    axios
      .post(
        "https://tjk09pd11a.execute-api.eu-north-1.amazonaws.com/dev/",
        {
          setActive: id,
        },
        {
          headers: {
            Authorization: user.signInUserSession.idToken.jwtToken,
          },
        }
      )
      .then((res) => {
        setLoadingActive(false);
        setActive(id);
      });
  };

  const acceptCampaign = (campaign_id, status) => {
    setLoadingAccept(true);
    // console.log("STATUS: " + status);
    axios
      .post(
        "https://024ujhjuvf.execute-api.eu-north-1.amazonaws.com/accept-campaign-trigger/",
        {
          status: status,
          campaign_id: campaign_id,
          streamer_id: streamerId,
        },
        {
          headers: {
            Authorization: user.signInUserSession.idToken.jwtToken,
          },
        }
      )
      .then((res) => {
        setLoadingAccept(false);
        const accept = status;
        setAccept(accept);
        if (status == false && active == campaign_id) {
          changeActive("");
        }
        if (status == true && active == "") {
          changeActive(campaign_id);
        }
      });
  };

  if (campaigns?.length && campaignSelected === "false") {
    return (
      <motion.div
        className="cardsMedia"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        style={{ overflowY: "hidden" }}
      >
        <Modal
          size={matches ? "60%" : "100vw"}
          opened={opened}
          onClose={() => setOpened(false)}
          overflow="outside"
          lockScroll
          transitionDuration={500}
          transitionTimingFunction="ease-in-out"
        >
          <SelectedCampaign details={currentDetails} setOpened={setOpened} />
        </Modal>
        <Modal
          size={500}
          opened={opened2}
          onClose={() => setOpened2(false)}
          overflow="outside"
          lockScroll
          mt={"15%"}
          transitionDuration={500}
          transitionTimingFunction="ease-in-out"
        >
          <UploadVOD
            setUploaded={setUploaded}
            setOpened2={setOpened2}
            opened2={opened2}
            uploaded={uploaded}
            user={user}
            details={currentDetails}
          />
        </Modal>
        <div
          style={{
            display: matches ? "flex" : "block",
            justifyContent: "space-evenly",
            alignItems: "center",
            padding: 10,
          }}
        >
          <div style={{ maxWidth: 450 }}>
            <Text size="28px" weight={600}>
              Sponsorships
            </Text>
            <Text color="dimmed" size={16}>
              Earn extra while streaming, join our paid sponsorships today.
            </Text>
          </div>
          <Card
            shadow="sm"
            p="lg"
            m="lg"
            radius="md"
            withBorder
            style={{
              minHeight: "200px",
              minWidth: "35%",
              display: "flex",
              // alignItems: "center",
              justifyContent: "space-evenly",
              boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.2)",
            }}
          >

            <div
              style={{
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                minWidth: "50%",
                height: "100%",
              }}
            >
                          <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
                <Wallet size="28px" color="white" style={{ padding: 7,borderRadius: 5, backgroundColor: "#49A7F4"
              }} />
                  <Text color="dimmed" size="md" weight={"bold"} ml={10} >
                    Wallet
                  </Text>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "5vh"}}>       

                  <Text size="20px" italic weight="semi-bold" color="dimmed" ml={-20}>
                    Coming Soon
                  </Text>
        
              </div>
            </div>
            <Divider orientation="vertical" />
            <LoadingOverlay visible={loading != true ? true : false} />
            <div
              style={{
                // display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                paddingLeft: 20,
                minWidth: "50%",
                height: "100%",
              }}
            >
                          <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
                <ActivityHeartbeat size="28px" color="white" style={{ padding: 7,borderRadius: 5, backgroundColor: "#49A7F4"
              }} />
                  <Text color="dimmed" size="md" weight={"bold"} ml={10} >
                    Active Sponsorships
                  </Text>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "1.5vh"}}>       

                  <Text size="60px" weight="bold">
                    {activeSponsors}
                  </Text>
        
              </div>
            </div>
          </Card>
        </div>
        <div
          style={{
            // width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              minHeight: "500px",
              padding: 10,
              marginLeft: "5%",
              marginRight: "5%",
              marginBottom: "1%",
              borderRadius: 10,
              boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.2)",
            }}
          >
            <Tabs defaultValue="gallery" height="20rem">
              <Tabs.List>
                <Tabs.Tab value="gallery" icon={<IconArchive size={20} />}>
                  <Text weight={500}>My Sponsorships</Text>
                </Tabs.Tab>
                <Tabs.Tab value="messages" icon={<IconSearch size={20} />}>
                  <Text weight={500}>Available Sponsorships</Text>
                </Tabs.Tab>
              </Tabs.List>
              <Tabs.Panel value="gallery" pt="xs">
                <Table
                  striped
                  highlightOnHover
                  horizontalSpacing="sm"
                  verticalSpacing="sm"
                >
                  <thead>
                    <tr>
                      <th>Campaign</th>
                      <th>Status</th>
                      <th>Views</th>
                      <th>Clicks</th>
                      <th>Link To VOD</th>
                      <th>Approved VODs (Uploaded)</th>
                      <th>Deadline</th>
                      <th>Earned</th>
                    </tr>
                  </thead>
                  <tbody>
                    {campaigns.map((n, index) => {
                      return (
                        <>
                          {n.streamers.state == "Accepted" &&
                          n.campaignState != "false" ? (
                            <tr
                              key={index}
                              style={{
                                opacity:
                                  active == n.campaign_id ? "100%" : "75%",
                              }}
                            >
                              <td>
                                <div style={{ display: "flex" }}>
                                  {n.campaign_name}
                                  <Tooltip label="Click for campaign details">
                                    <div>
                                      <IconQuestionMark
                                        size={12}
                                        style={{
                                          display: "block",
                                          opacity: 0.5,
                                          border: "1px solid #161616",
                                          borderRadius: 10,
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          setCurrentDetails(n);
                                          setOpened(true);
                                        }}
                                      />
                                    </div>
                                  </Tooltip>
                                </div>
                              </td>

                              <td>
                                <Button
                                  disabled={loadingActive ? true : false}
                                  size="xs"
                                  onClick={() => {
                                    active == n?.campaign_id
                                      ? changeActive("")
                                      : changeActive(n?.campaign_id);
                                  }}
                                  color={
                                    n?.campaign_id === active ? "green" : "red"
                                  }
                                  variant={
                                    n?.campaign_id === active ? "" : "outline"
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  {!loadingActive ? (
                                    n?.campaign_id === active ? (
                                      "Active"
                                    ) : (
                                      "Inactive"
                                    )
                                  ) : (
                                    <>
                                      <Text size="xs">Loading</Text>
                                      <Loader color="white" size="sm" />
                                    </>
                                  )}
                                </Button>
                              </td>
                              <td><Text>{typeof n?.streamers?.submitted_vods != "undefined" ? (n?.streamers?.submitted_vods.reduce((partialSum, a) => partialSum + a.viewer_count, 0) / 2).toLocaleString() : 0}</Text></td>
                              <td>

                               <Text>{n?.streamers?.bitlink_data?.data?.reduce((a, b) => a + b.clicks, 0)}</Text> 
                              </td>
                              <td>
                                {n?.streamers?.submitted_vods !=
                                n?.number_of_streams ? (
                                  <Button
                                    size="xs"
                                    variant="outline"
                                    onClick={() => {
                                      setCurrentDetails(n);
                                      setOpened2(true);
                                    }}
                                  >
                                    Add VOD
                                  </Button>
                                ) : (
                                  <Button size="xs" variant="outline" disabled>
                                    Done
                                  </Button>
                                )}
                              </td>
                              <td>
                                <Text style={{ display: "flex" }}>
                                  <Text>
                                    {n?.streamers.vods.length} /{" "}
                                    {n?.number_of_streams}
                                  </Text>
                                  <Text ml={5}>
                                  ({typeof n?.streamers.submitted_vods?.length != "undefined" ? n?.streamers.submitted_vods?.length : 0})
                                </Text>
                                </Text>
                              </td>
                              <td>
                                <Text weight="700">
                                  {typeof n?.end_date != "undefined" ?                                   
                                  Math.floor(
                                    (new Date(n?.end_date) - today) /
                                      (1000 * 60 * 60 * 24)
                                  ) + " days" : "N/A"}
      
                                </Text>
                              </td>
                              <td>
                                €
                                {n?.streamers.vods.length > 0
                                  ? parseInt(n?.streamers.invoice) /
                                    parseInt(n?.streamers.vods.length)
                                  : 0}{" "}
                                / €{n?.streamers.invoice}
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}
                        </>
                      );
                    })}
                  </tbody>
                  <caption>
                    Only one sponsorship can be active per stream, select which
                    to activate for your next stream.
                  </caption>
                </Table>
              </Tabs.Panel>
              <Tabs.Panel value="messages" pt="xs">
                <div
                  style={{
                    marginBottom: "10px",
                    padding: 10,
                    marginLeft: "3%",
                  }}
                ></div>
                <div style={{ marginLeft: "5%" }}>
                  {campaigns.map((n, index) => {
                    return (
                      <motion.div
                        whileHover={{ scale: 1.01 }}
                        whileTap={{ scale: 0.99 }}
                        style={{
                          width: "300px",
                          display: "inline-block",
                          paddingRight: "20px",
                          paddingBottom: "20px",
                          marginRight: 10,
                        }}
                        key={index}
                      >
                        {n.campaignState == "true" ? (
                          <div key={index}>
                            <Card
                              shadow="sm"
                              p="lg"
                              radius="md"
                              withBorder
                              style={{ minHxeight: "310px" }}
                            >
                              <Card.Section>
                                <Image
                                  src={n?.thumbnail_url}
                                  withPlaceholder
                                  placeholder={
                                    <Text align="center" size="sm" weight={700}>
                                      {n?.campaign_name}
                                    </Text>
                                  }
                                  height={150}
                                  alt="Voon"
                                />
                              </Card.Section>
                              <LoadingOverlay
                                visible={loading != true ? true : false}
                              />
                              <Group position="apart" mt="sm">
                                <Text weight={500}>{n?.campaign_name}</Text>
                              </Group>
                              <Text lineClamp={3} size="xs" color="dimmed">
                                {n?.campaign_info}
                              </Text>
                              <div>
                                <Group
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Button
                                    variant="light"
                                    color="blue"
                                    mt="md"
                                    size="xs"
                                    radius="md"
                                    onClick={() => {
                                      setCurrentDetails(n);
                                      setOpened(true);
                                    }}
                                  >
                                    View Details
                                  </Button>
                                  <Button
                                    mt="md"
                                    disabled={loadingAccept ? true : false}
                                    size="xs"
                                    radius="md"
                                    variant={
                                      n.streamers.state == "Accepted"
                                        ? "filled"
                                        : "outline"
                                    }
                                    color={
                                      n.streamers.state == "Accepted"
                                        ? "green"
                                        : "blue"
                                    }
                                    onClick={() => {
                                      if (n.streamers.state == "Accepted") {
                                        const acc = false;
                                        acceptCampaign(n.campaign_id, acc);
                                      } else {
                                        const acc = true;
                                        acceptCampaign(n.campaign_id, acc);
                                      }
                                    }}
                                  >
                                    {!loadingAccept ? (
                                      n.streamers.state == "Accepted" ? (
                                        "Leave"
                                      ) : (
                                        "Accept"
                                      )
                                    ) : (
                                      <>
                                        <Text size="xs">Loading</Text>
                                        <Loader color="white" size="sm" />
                                      </>
                                    )}
                                  </Button>
                                </Group>
                              </div>
                            </Card>
                          </div>
                        ) : (
                          <div key={index}>
                          
                          </div>
                        )}
                      </motion.div>
                    );
                  })}
                </div>
              </Tabs.Panel>
            </Tabs>
          </div>
        </div>
      </motion.div>
    );
  } else if (campaigns?.length === 0 && selected) {
    return (
      <motion.div
        className="cardsMedia"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            padding: 10,
          }}
        >
          <div style={{ maxWidth: 450 }}>
            <Text size="28px" weight={600}>
              Sponsorships
            </Text>
            <Text color="dimmed" size={16}>
              Earn extra while streaming, join our paid sponsorships today.
            </Text>
          </div>
          <Card
            shadow="sm"
            p="lg"
            m="lg"
            radius="md"
            withBorder
            style={{
              minHeight: "200px",
              width: "35%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.2)",
            }}
          >
            <LoadingOverlay visible={loading != true ? true : false} />
            <Text size="24px" weight="semi-bold">
              Active Sponsorships:
            </Text>
            <Text size="32px" weight="bold" ml={10}>
              {activeSponsors}
            </Text>
          </Card>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              minHeight: "450px",
              padding: 10,
              marginLeft: "5%",
              marginRight: "5%",
              marginBottom: "1%",
              borderRadius: 10,
              boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.2)",
            }}
          >
            <Tabs defaultValue="gallery" height="20rem">
              <Tabs.List>
                <Tabs.Tab value="gallery" icon={<IconArchive size={20} />}>
                  <Text weight={500}>My Sponsorships</Text>
                </Tabs.Tab>
                <Tabs.Tab value="messages" icon={<IconSearch size={20} />}>
                  <Text weight={500}>Available Sponsorships</Text>
                </Tabs.Tab>
              </Tabs.List>
              <Tabs.Panel value="gallery" pt="xs">
                No sponsorships available right now, come back later!
              </Tabs.Panel>
              <Tabs.Panel value="messages" pt="xs">
                No sponsorships available right now, come back later!
              </Tabs.Panel>
            </Tabs>
          </div>
        </div>
        {/* <Divider ml={"5%"} mr={"5%"} size="md" mt={40} />
        <div style={{ marginBottom: "10px", paddingTop: 20, marginLeft: "5%" }}>
          <Text size={20} weight={700}>
            Previous Sponsorships
          </Text>
          <Text size={14}>
            Interested in working with prominent brands from across the globe?
          </Text>
        </div>
        <div style={{ marginLeft: "5%" }}>
          {featuredCampaigns.map((c, index) => {
            return (
              <motion.div
                style={{
                  width: "300px",
                  display: "inline-block",
                  paddingRight: "20px",
                  paddingBottom: "20px",
                  marginRight: 10,
                  opacity: "75%",
                }}
                key={index}
              >
                <div>
                  <Card
                    shadow="sm"
                    p="lg"
                    radius="md"
                    withBorder
                    style={{ height: "300px" }}
                  >
                    <Card.Section>
                      <Image
                        src={c.src}
                        withPlaceholder
                        placeholder={
                          <Text align="center" size="sm" weight={700}>
                            No Image
                          </Text>
                        }
                        height={160}
                        alt="Voon"
                      />
                    </Card.Section>
                    <LoadingOverlay visible={loading != true ? true : false} />
                    <Group position="apart" mt="md" mb="xs">
                      <Text weight={500}>Nope - The Movie</Text>
                    </Group>
                    <Group position="center" mb="xs">
                      <Badge>Finished</Badge>
                    </Group>
                    <Divider />
                    <Group position="center" mt="md" mb="xs">
                      <Text lineClamp={3} size="sm" color="dimmed">
                        2022.08.12 - 2022.09.01
                      </Text>
                    </Group>
                  </Card>
                </div>
              </motion.div>
            );
          })}
        </div> */}
      </motion.div>
    );
  } else if (!selected) {
    return (
      <>
        <h1 className="App">Link twitch account to view your campaigns</h1>
        <HomePage />
      </>
    );
  } else if (campaignSelected === "true") {
    return <SelectedCampaign details={currentDetails} />;
  } else {
    return (
      <>
        <LoadingOverlay size="xl" visible={loading != true ? true : false} />
      </>
    );
  }
}

export default withAuthenticator(ActiveCampaigns);
